import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../data/offer';
type Props = {
  label: string;
  sub?: string;
  id?: string;
  tone?: 'dark' | 'light';
  className?: string;
};
export function CTAButton({
  label,
  sub,
  id,
  tone = 'dark',
  className = ''
}: Props) {
  return <div className={`flex w-full flex-col items-center text-center ${className}`} data-id="element-354" data-mp="1l996ipb4dpl4">
      <a id={id} href={CHECKOUT_URL} onClick={trackCheckout} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-5 py-5 font-display text-[17px] font-black uppercase leading-tight tracking-tight text-ink shadow-cta transition-[transform,background-color] duration-150 ease-out hover:bg-gold-light active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan/60 md:px-8 md:text-xl" data-id="element-355" data-mp="16kw7fjgqjqme">
        <span className="text-balance" data-id="element-356" data-mp="sldbrq5427qz">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-357" data-mp="sl3hvrgy3gg0" />
      </a>
      {sub && <p className={`mt-3 text-sm font-medium ${tone === 'dark' ? 'text-white/70' : 'text-body'}`} data-id="element-358" data-mp="3efnedsve5f16">{sub}</p>}
    </div>;
}
function trackCheckout() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout', {
      value: 27,
      currency: 'USD'
    });
  }
}